import React,{useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import PropagateLoader from "react-spinners/PropagateLoader";
import {URL} from '../Helper/helper'
import { invokeBookings, invokeReservations } from '../ServiceCalls/ApiCalls';
import { ToastContainer, toast } from 'react-toastify';
import './LoginComponent.css'

import 'react-toastify/dist/ReactToastify.css';

function LoginComponent() {

  const[username,setUsername] = useState('')
  const[password,setPassword] = useState('')
  const[loading,setLoading] = useState(false)
  const[error,setError] = useState(false)
  const[color,setColor] = useState('#36d7b7')
  const[btndisabled,setBtnDisabled] = useState(false)

  const navigate = useNavigate()

  useEffect(() =>{
        // console.log('Login Component Loaded...')

  },[])

  const handleNameChange = (e) =>{
    setUsername(e.target.value)
  }
  const handlePasswordChange = (e) =>{
    setPassword(e.target.value)
  }
  const invokeUserBookings = async() =>{
    //const bookingsData = await fetch(`${URL}`+'/bookings')
    const bookingResponse = await invokeBookings()
    localStorage.setItem('userBookings',JSON.stringify(bookingResponse))
  }
  const invokeUserReservations = async() =>{
    const perbookingResponse = await invokeReservations();
    localStorage.setItem('perReservations',JSON.stringify(perbookingResponse))
  }
  async function loginUser(e){

     e.preventDefault()
     if(username.length > 0 && password.length > 0){
        setLoading(true)
        setBtnDisabled(prev => !prev)
     }
    // console.log('Login User Function Started...')
    try{
        const options = {
            method:'POST',
            headers:{
            "Access-Control-Allow-Origin":"*",
            "Content-Type":"application/json"
            },
            mode:'cors',
            body:JSON.stringify({userName:username,password:password})
        }
        const response = await fetch(`${URL}`+'/login',options)
        const user_info = await response.json()

        if(response.ok){
            localStorage.setItem('user',JSON.stringify(user_info))
            localStorage.setItem('isLoggedIn',true)
            
            // Dispatch custom event to notify App.js of login state change
            window.dispatchEvent(new Event('loginStateChange'))
            
            invokeUserBookings()
            invokeUserReservations()
            setBtnDisabled(true)
            setLoading(false)
            if(user_info.isAdmin)
                navigate('/user')
            else
                navigate('/user')
        }
        else{
          setLoading(false)
          setBtnDisabled(false)
          // setError(true)
          toast.error('🦄 Oops Wrong Creds!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
          setUsername('')
          setPassword('')
        }

    }
    catch(err){
        console.log(err)
    }

  }
  return (
    <div className='login-page'>
        <div className='container admin-container'>
            <div className="row mt-5">
                <div className="col-md-12 col-sm-12">
                    <div className="login-header d-flex justify-content-center align-items-center mb-5">
                        <div className="text-center">
                            <h3 className="mb-1">
                                <i className="fa fa-user text-warning me-2"></i>
                                Welcome Back
                            </h3>
                            <p className="text-muted">Please sign in to your account</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-5">
                    <div className="login-card">
                        <div className="login-card-header">
                            <div className="login-icon">
                                <i className="fa fa-lock fa-2x text-primary"></i>
                            </div>
                            <h4 className="login-title">Sign In</h4>
                            <p className="login-subtitle">Access your badminton dashboard</p>
                        </div>

                        <div className="login-card-body">
                            {/* Loading Spinner */}
                            {loading && (
                                <div className="login-loading">
                                    <PropagateLoader
                                        loading={loading}
                                        color={color}
                                        size={15}
                                    />
                                    <p className="loading-text">Signing you in...</p>
                                </div>
                            )}

                            {/* Error Alert */}
                            {error && (
                                <div className="alert alert-danger text-center alert-dismissible fade show">
                                    <i className="fa fa-exclamation-triangle me-2"></i>
                                    <span>Invalid User Credentials!</span>
                                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            )}

                            <form onSubmit={loginUser} className="login-form">
                                <div className="form-group">
                                    <label htmlFor="username" className="form-label">
                                        <i className="fa fa-user me-2"></i>Username
                                    </label>
                                    <input 
                                        type="text" 
                                        className="form-control login-input" 
                                        id="username" 
                                        name="username" 
                                        placeholder="Enter your username"
                                        required
                                        value={username} 
                                        onChange={handleNameChange}
                                        disabled={loading}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password" className="form-label">
                                        <i className="fa fa-lock me-2"></i>Password
                                    </label>
                                    <input 
                                        type="password" 
                                        className="form-control login-input" 
                                        id="password" 
                                        name="password" 
                                        placeholder="Enter your password"
                                        required
                                        value={password} 
                                        onChange={handlePasswordChange}
                                        disabled={loading}
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className={`btn login-btn w-100 ${loading ? 'loading' : ''}`}
                                    disabled={btndisabled || loading}
                                >
                                    {loading ? (
                                        <>
                                            <i className="fa fa-spinner fa-spin me-2"></i>
                                            Signing In...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-sign-in me-2"></i>
                                            Sign In
                                        </>
                                    )}
                                </button>
                            </form>
                        </div>

                        <div className="login-card-footer">
                            <div className="login-help">
                                <small className="text-muted">
                                    <i className="fa fa-info-circle me-1"></i>
                                    Need help? Contact admin for account assistance
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ToastContainer/>
    </div>
  )
}

export default LoginComponent